import { NetworkService } from "../../../services/network.service";

/**
 * Needs to be implemented by all 
 * Request which want to use the networkservice.executeBaseAtlasPostRequest()
 */
export abstract class BaseAtlasRequest{
    abstract readonly operationName: string;
    abstract body: any;

    constructor() {}

    /**
     * @returns the request body
     */
    public getBody(): any{
        return this.body;
    }

}